import { render } from "./From.vue?vue&type=template&id=3e495136&scoped=true&ts=true"
import script from "./From.vue?vue&type=script&lang=ts"
export * from "./From.vue?vue&type=script&lang=ts"

import "./From.vue?vue&type=style&index=0&id=3e495136&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e495136"]])

export default __exports__